import { cn } from '../cn';

export interface LogoProps {
  className?: string;
  /** light: fundo claro/adaptável (default). dark: fundo sempre escuro (sidebar, auth, footer). */
  tone?: 'light' | 'dark';
}

/** Logos oficiais — servidas via public/ (Vite e Next expõem public/ na raiz). */
const WHITE_LOGO_SRC = '/brand/pnl-logo-white.png';
const NAVY_LOGO_SRC = '/brand/pnl-logo-navy.png';

/**
 * Marca "PnL Global" (logo oficial).
 * - tone="dark": superfície sempre escura (sidebar, auth panel, footer) → logo branca.
 * - tone="light" (default): theme-aware via classe `.dark` no <html> → logo navy no tema
 *   claro e logo branca no tema escuro.
 */
export function Logo({ className, tone = 'light' }: LogoProps) {
  if (tone === 'dark') {
    return (
      <span className={cn('inline-flex items-center', className)}>
        <img src={WHITE_LOGO_SRC} alt="PnL Global" className="h-7 w-auto" />
      </span>
    );
  }

  return (
    <span className={cn('inline-flex items-center', className)}>
      {/* Tema claro: logo navy. Tema escuro: logo branca. */}
      <img src={NAVY_LOGO_SRC} alt="PnL Global" className="h-7 w-auto dark:hidden" />
      <img src={WHITE_LOGO_SRC} alt="PnL Global" className="hidden h-7 w-auto dark:block" />
    </span>
  );
}
